<script lang="ts" setup>
/*---------------------------------------------
/  PROPS & EMITS
---------------------------------------------*/
/*---------------------------------------------
/  VARIABLES
---------------------------------------------*/
const logo = new URL('@/assets/img/panel_logo.png', import.meta.url);
/*---------------------------------------------
/  METHODS
---------------------------------------------*/
/*---------------------------------------------
/  COMPUTED
---------------------------------------------*/
/*---------------------------------------------
/  WATCHERS
---------------------------------------------*/
/*---------------------------------------------
/  CREATED
---------------------------------------------*/
/*---------------------------------------------
/  HOOKS
---------------------------------------------*/
</script>
<template>
	<footer class="footer-component mt-5">
		<div class="container">
			<div class="d-flex flex-column flex-lg-row align-items-center justify-content-between">
				<div class="logo-container">
					<img
						:src="logo.href"
						class="header-logo"
						width="50" />
				</div>
				<div class="link-container d-flex text-center mt-4 mt-lg-0 mb-4 mb-lg-0 flex-column flex-lg-row  gap-4">
					<a
						href="https://panelstory.hu/urlapkezelo-rendszer-adatvedelmi-tajekoztato/"
						target="_blank"
						rel="noopener noreferrer">Adatvédelmi tájékoztató</a>
					<a
						href="https://panelstory.hu/urlapkezelo-rendszer-altalanos-szerzodesi-feltetelek/"
						target="_blank"
						rel="noopener noreferrer">Általános Szerződési Feltételek</a>
				</div>
				<div class="info">
					&copy; {{ new Date().getFullYear() }} panel-story
				</div>
			</div>
		</div>
	</footer>
</template>
<style src="./Footer.scss" lang="scss" scoped />
